// extracted by mini-css-extract-plugin
module.exports = {"root":"_2e6Ul","text":"_3GAuD"};